import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoginProps } from "../../types/screensTypes";
import TextInput from "../../components/ui/TextInput";
import styles from "./Login.module.css";

const Login: React.FC<LoginProps> = ({ onLogin }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string>("");

    const submitLogin = async () => {
        setError("");

        if (!email || !password) {
            setError(t("emailAndPasswordRequired"));
            return;
        }

        try {
            const result = await onLogin(email, password);

            if (!result) {
                setError(t("invalidCredentials"));
                return;
            }
        } catch (err: any) {
            if (err?.statusCode === 429) {
                setError(t("tooManyLoginAttempts"));
            } else if (err?.statusCode === 401) {
                setError(t("invalidCredentials"));
            } else {
                setError(t("anErrorOccurred"));
            }
        }
    };

    const onKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            e.preventDefault();
            void submitLogin();
        }
    };

    return (
        <div className={styles.page}>
            <div className={styles.card}>
                <h1 className={styles.title}>{t("login")}</h1>
                <p className={styles.subtitle}>{t("loginSubtitle")}</p>

                <div className={styles.form} onKeyDown={onKeyDown}>
                    <div className={styles.field}>
                        <TextInput
                            placeholder={t("enterYourEmailMandatory")}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className={styles.field}>
                        <TextInput
                            placeholder={t("enterYourPasswordMandatory")}
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    {error && <p className={styles.error}>{error}</p>}

                    <p className={styles.forgot}>
                        <a href="/forgotten-password">{t("iForgotMyPassword")}</a>
                    </p>

                    <button type="button" className={styles.submit} onClick={submitLogin}>
                        {t("login")}
                    </button>
                </div>

                <p className={styles.footer}>
                    {t("noAccountYetQuestion")} <a href="/register">{t("createOne")}</a>
                </p>
            </div>
        </div>
    );
};

export default Login;
